var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"toolbar"}},[_c('el-button',{on:{"click":_vm.checkInvert}},[_vm._v("\n      checkInvert\n    ")])],1),_c('element-table',{ref:"table",attrs:{"columns":_vm.columns,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }